import {
  Component,
  ContentChild,
  Input,
  TemplateRef,
  inject,
} from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { PayeeHeaderComponent } from '../../../shared/payee-header/payee-header.component';
import { PayeeIconButtonComponent } from '../../../shared/payee-buttons/payee-icon-button/payee-icon-button.component';
import { PayeeIconComponent } from '../../../shared/payee-icon/payee-icon.component';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-header-empty',
  templateUrl: './header-empty.component.html',
  styleUrls: ['./header-empty.component.scss'],
  imports: [
    PayeeHeaderComponent,
    PayeeIconButtonComponent,
    PayeeIconComponent,
    NgTemplateOutlet,
  ],
})
export class HeaderEmptyComponent {
  private authService = inject(AuthService);

  @Input() payeeLink = environment.HELP_URL; // 'https://payee.tech';

  @ContentChild('logoTemplate') logoTemplateRef!: TemplateRef<unknown>;
  @ContentChild('buttonTemplate') buttonTemplateRef!: TemplateRef<unknown>;

  async logout(): Promise<void> {
    await this.authService.logout();
  }
}
